exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "region-selection news12-button button{width:16vw}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/regionSelection/regionSelection.scss
 ** module id = 108
 ** module chunks = 0
 **/